import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ReportCloneMetaData } from './report-clone-client.types';

@Injectable({
  providedIn: 'root',
})
export class ReportCloneClientService {
  constructor(private http: HttpClient) {}

  initiateReportClone(
    ownerId: string,
    reportId: string,
    runId: string,
    reportWorkspace: string
  ): Observable<ReportCloneMetaData> {
    const url = `/api/${reportWorkspace}/reports/${reportId}/runs/${runId}/duplicates`;
    return this.http.post<ReportCloneMetaData>(url, { owner_id: ownerId });
  }
}
